<script lang="tsx">
  import Navbar from "./Navbar.vue";
  import NavbarSkeleton from "./NavbarSkeleton.vue";

  export default {
    components: { Navbar, NavbarSkeleton },
    props: Navbar.props as (typeof Navbar["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <Navbar v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <NavbarSkeleton width="100%" height="100%"/>
    </template>
  </Suspense>
</template>
